
const mode = 1// 1 for production and 0 for development

export default mode;
